import { Box, alpha, styled } from '@mui/material';
import { ImgBox } from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.fogWhite,
  boxShadow: '5px 4px 24px 0px rgba(0, 0, 0, 0.08)',
  zIndex: theme.zIndex.appBar,
  position: 'relative',
  '& .AAMContainer': {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  '& .AAMImageText': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  '& .AAMTitle': {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.alternate,
    lineHeight: '140%',
  },
  '& .AAMDesc': {
    fontSize: theme.typography.pxToRem(11),
    color: theme.palette.text.alternate,
    lineHeight: 'auto',
  },
  '& .AAMClosseIcon': {
    fontSize: theme.typography.pxToRem(16),
    color: alpha(theme.palette.text.alternate, 0.7),
  },
  '& .AAMGetBtn': {
    borderRadius: theme.spacing(3),
    padding: theme.spacing(0.3, 1.5, 0, 1.5),
    fontSize: theme.typography.pxToRem(12),
    minWidth: 'auto',
    whiteSpace: 'nowrap',
  },
}));

export const StyledImgBox = styled(ImgBox)(({ theme }) => ({
  '&.IBimgbox': {
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(32),
      width: theme.typography.pxToRem(32),
    },
  },
}));
export default StyledBox;
